import { RenderMode, VariablesDataWithError } from '@follow/cdk'
import getApi from '../../../api/apisauceConfig'

export const fetchDocumentVariableData = (documentId: number, renderMode: RenderMode) =>
  getApi().get<VariablesDataWithError>(`documents/${documentId}/variable_data`, { renderMode })
